import FilesPanel from './FilesPanel';


export default FilesPanel;
